<template>
  <div v-if="itemData">
    <div class="smartkey setbox"
      :style="setDetailStyle(itemData.column[0].detail)">
      4208 9657 2699
      <!-- 모바일키 디테일 세팅 -->
      <div class="handleColumn"
        v-if="itemData.column[0] && itemData.column[0].detail">
        <button type="button" class="handle setDetail"
          @click="setDetail($event, itemData.column[0].detail)"></button>
      </div>
      <!-- // 모바일키 디테일 세팅 -->
    </div>
    <div v-if="isRemotekey"
      class="remotekey setbox standardImage hasImg"
      :style="setDetailStyle(itemData.column[1].detail)">
      <img v-if="itemData.column[1].detail.remotekey.img" :src="itemData.column[1].detail.remotekey.img" />
      <div v-else class="defaultImg">OPEN</div>
      <!-- 리모트키 디테일 세팅 -->
      <div class="handleColumn"
        v-if="itemData.column[1] && itemData.column[1].detail">
        <button type="button" class="handle setDetail"
          @click="setDetail($event, itemData.column[1].detail)"></button>
      </div>
      <!-- // 리모트키 디테일 세팅 -->
      <!-- 리모트 아이콘 이미지 업로드 및 편집 -->
      <div class="editImage">
        <label class="uploadImg">
          <input type="file" @change="uploadImage($event)">
        </label>
        <button v-if="itemData.column[1].detail.remotekey.img" type="button" class="btnDel" @click="delImage($event)"></button>
      </div>
      <!-- // 리모트 아이콘 이미지 업로드 및 편집 -->
    </div>
  </div>
</template>

<script>
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'

export default {
  name: 'SmartkeyModule',
  props: [
    'locale',
    'isNew',
    'id',
    'moduleIndex',
    'itemData',
    'itemSetting'
  ],
  computed: {
    isRemotekey () {
      const detail = this.itemData.column[0].detail
      return detail.smartkey && detail.smartkey.remotekey
    }
  },
  methods: {
    setDetailStyle (detailData) {
      const notStyles = ['options']
      const styles = Object.keys(detailData).filter(function (o) {
        return notStyles.indexOf(o) === -1
      })
      const styleObj = {}
      styles.forEach(function (x) {
        const obj = detailData[x]
        if (obj && obj.active) {
          let key = ''
          let value = ''
          switch (x) {
            case 'background':
              Object.keys(obj).forEach(function (o) {
                key = `${x}-${o}`
                value = obj[o]
                styleObj[key] = value
              })
              break
            case 'padding':
              styleObj['padding-top'] = `${obj.tb}px`
              styleObj['padding-bottom'] = `${obj.tb}px`
              styleObj['padding-left'] = `${obj.lr}px`
              styleObj['padding-right'] = `${obj.lr}px`
              break
            case 'border':
              styleObj['border-width'] = '1px'
              Object.keys(obj).forEach(function (o) {
                key = `${x}-${o}`
                value = obj[o]
                styleObj[key] = value
              })
              break
            case 'radius':
              styleObj['border-radius'] = `${obj.tl}px ${obj.tr}px ${obj.br}px ${obj.bl}px`
              break
            case 'text':
              styleObj.color = obj.color
              break
          }
        }
        if (x === 'smartkey') {
          styleObj['font-size'] = `${obj.size}px`
          styleObj['text-align'] = `${obj.align}`
        }
        if (x === 'remotekey') {
          styleObj['margin-top'] = `${obj.margin}px`
          styleObj['max-width'] = obj.size !== '100' ? `${obj.size}%` : 'none'
        }
      })
      return styleObj
    },
    setDetail (e, detail) {
      e.stopPropagation()
      const setbox = document.querySelectorAll('.setbox')
      const target = e.target.closest('.setbox')
      setbox.forEach(el => el.classList.remove('active'))
      target.classList.add('active')
      this.$emit('setDetail', detail)
    },
    uploadImage (e) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0]
      }
      const isImage = regExp.image.test(data.file.name.slice(data.file.name.lastIndexOf('.') + 1).toLowerCase())
      if (isImage) {
        this.$store.dispatch('util/uploadFile', data).then((res) => {
          this.itemData.column[1].detail.remotekey.img = res.source
          e.target.value = ''
        })
      } else {
        alert(this.locale.validate_upload_image)
      }
    },
    delImage (e) {
      e.stopPropagation()
      if (window.confirm(this.locale.confirm_delete_image)) {
        this.itemData.column[1].detail.remotekey.img = ''
      }
    }
  }
}
</script>
